import _request from '@/utils/request.js'
var _paymentService = {
    paymentList (query, resolve, reject) {
        _request.api({
          url: _request.getCrmUrl("/api/paymentCollection/getListPage"),
          params: query,
          method: 'get',
          success: resolve,
          error: reject
        })
    },
    paymentTypeList (query, resolve, reject) {
      _request.api({
        url: _request.getCrmUrl("/api/common/selectEnum"),
        params: query,
        method: 'get',
        success: resolve,
        error: reject
      })
    },
    paymentAllList (query, resolve, reject) {
      _request.api({
        url: _request.getCrmUrl("/api/paymentCollection/getListPageAll"),
        params: query,
        method: 'get',
        success: resolve,
        error: reject
      })
    },
    getVerifDeadline (resolve, reject) {
      _request.api({
        url: _request.getCrmUrl("/api/paymentCollection/getVerifDeadline"),
        method: 'get',
        success: resolve,
        error: reject
      })
    },
    getEditVerifDeadline (query, resolve, reject) {
      _request.api({
        url: _request.getCrmUrl("/api/paymentCollection/editVerifDeadline"),
        data: query,
        method: 'post',
        success: resolve,
        error: reject
      })
    },
    getQueryCollectionPeriod (query, resolve, reject) {
      _request.api({
        url: _request.getCrmUrl("/api/paymentCollection/queryCollectionPeriod"),
        data: query,
        method: 'post',
        success: resolve,
        error: reject
      })
    },
    getVerifyOuterOrder (query, resolve, reject) {
      _request.api({
        url: _request.getCrmUrl("/api/paymentCollection/verifyOuterOrder"),
        data: query,
        method: 'post',
        success: resolve,
        error: reject
      })
    },
    getQueryOrderList (query, resolve, reject) {
      _request.api({
        url: _request.getCrmUrl("/api/paymentCollection/queryOrderList"),
        data: query,
        method: 'post',
        success: resolve,
        error: reject
      })
    },
    getVerifyCrmOrder (query, resolve, reject) {
      _request.api({
        url: _request.getCrmUrl("/api/paymentCollection/verifyCrmOrder"),
        data: query,
        method: 'post',
        success: resolve,
        error: reject
      })
    },
    orderVerifyList (query, resolve, reject) {
      _request.api({
        url: _request.getCrmUrl("/api/paymentCollection/orderVerifyList"),
        params: query,
        method: 'get',
        success: resolve,
        error: reject
      })
    },
    getVerifyLogList (query, resolve, reject) {
      _request.api({
        url: _request.getCrmUrl("/api/paymentCollection/getVerifyLogList"),
        params: query,
        method: 'get',
        success: resolve,
        error: reject
      })
    },
    orderVerifyDetail (query, resolve, reject) {
      _request.api({
        url: _request.getCrmUrl("/api/paymentCollection/orderVerifyDetail"),
        params: query,
        method: 'get',
        success: resolve,
        error: reject
      })
    },
    queryLeftAmount (query, resolve, reject) {
      _request.api({
        url: _request.getCrmUrl("/api/paymentCollection/queryLeftAmount"),
        data: query,
        method: 'post',
        success: resolve,
        error: reject
      })
    },
    updateVerifyAmount (query, resolve, reject) {
      _request.api({
        url: _request.getCrmUrl("/api/paymentCollection/updateVerifyAmount"),
        data: query,
        method: 'post',
        success: resolve,
        error: reject
      })
    },
    updateVerifyAmountAdmin (query, resolve, reject) {
      _request.api({
        url: _request.getCrmUrl("/api/paymentCollection/updateVerifyAmountAdmin"),
        data: query,
        method: 'post',
        success: resolve,
        error: reject
      })
    },
    verifyReverse (query, resolve, reject) {
      _request.api({
        url: _request.getCrmUrl("/api/paymentCollection/verifyReverse"),
        data: query,
        method: 'post',
        success: resolve,
        error: reject
      })
    },
    verifyReverseAdmin (query, resolve, reject) {
      _request.api({
        url: _request.getCrmUrl("/api/paymentCollection/verifyReverseAdmin"),
        data: query,
        method: 'post',
        success: resolve,
        error: reject
      })
    },
        verifyReverseAdmin (query, resolve, reject) {
      _request.api({
        url: _request.getCrmUrl("/api/paymentCollection/verifyReverseAdmin"),
        data: query,
        method: 'post',
        success: resolve,
        error: reject
      })
    },
    exportVerifyExcel (query, resolve, reject) {
      _request.api({
        url: _request.getCrmUrl("/api/paymentCollection/exportVerifyExcel"),
        params: query,
        method: 'get',
        success: resolve,
        error: reject
      })
    },
    exportVerifyExcelOrder (query, resolve, reject) {
      _request.api({
        url: _request.getCrmUrl("/api/paymentCollection/exportVerifyExcelOrder"),
        params: query,
        method: 'get',
        success: resolve,
        error: reject
      })
    },
    getTemplate (resolve, reject) {
      _request.api({
        url: _request.getCrmUrl("/api/paymentCollection/verifyOuterOrder/template"),
        method: 'get',
        success: resolve,
        error: reject
      })
    },
    verifyOuterOrderImport (file, resolve, reject) {
      _request.upload({
        url: _request.getCrmUrl("/api/paymentCollection/verifyOuterOrder/byImport"),
        file: file,
        method: 'post',
        success: resolve,
        error: reject
      })
    },
    getImportResult (query, resolve, reject) {
      _request.api({
        url: _request.getCrmUrl("/api/paymentCollection/verifyOuterOrder/getImportResult"),
        params: query,
        method: 'get',
        success: resolve,
        error: reject
      })
    },
}
export default _paymentService